import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './HtEndpointScenarioEditor.html?raw';

import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../../moreCore/UI/Container/uiFrame';
import { HtEndpointScenario } from "../ScreenplayTypes";
import lang from 'dojo/_base/lang';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import TimeInput from '../../../moreCore/UI/TimeInput/TimeInput';

class HtEndpointScenarioEditor extends compose(_StatefulSection, _uiFrameMixin) {
    templateString: any = template;

    private inputDateStart: MdsLax<InstanceType<typeof DateInput>>;
    private inputDateEnd: MdsLax<InstanceType<typeof DateInput>>;
    private inputIsTimeRelative: MdsLax<InstanceType<typeof CheckBox>>;
    private inputTimeStart: MdsLax<InstanceType<typeof TimeInput>>;
    private inputTimeEnd: MdsLax<InstanceType<typeof TimeInput>>;


    setup(entity: HtEndpointScenario) {
        this.setData(lang.clone(entity));
        let title = `${this.translate("Endpoint_Heading_HtEndpointscenarioEditor")} - ${entity.$Displayname}`;
        this.show("dlg", title);
        this.createDefaultButton("ok", lang.hitch(this, this._onClickOk));
    }

    private _onClickOk() {
        this.emit("editorConfirmed", this.getCurrentData());
        this.close();
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        let source = this.getAttributeValue("ref_screenplay_scenario.source");
        if (source === "blocks") {
            this.hideNode(this.inputIsTimeRelative, false);
        } else {
            this.hideNode(this.inputIsTimeRelative, true);
            //this.hideNode(this.inputDateStart, true);
            //this.hideNode(this.inputDateEnd, true);
        }

        let isTimeRelative = this.getAttributeValue("is_time_relative_to_first_booking");
        if (isTimeRelative && source === "blocks") {
            this.hideNode(this.inputDateStart.domNode, true);
            this.hideNode(this.inputDateEnd.domNode, true);
        } else if (source === "blocks") {
            this.hideNode(this.inputDateStart.domNode, false);
            this.hideNode(this.inputDateEnd.domNode, false);
        }
        

        if (this.getAttributeValue("time_start")) {
            let startTime = new Date();
            let startTimeString: string = this.getAttributeValue("time_start");
            let startTimeValues = startTimeString.split(":");
            startTime.setHours(parseInt(startTimeValues[0]));
            startTime.setMinutes(parseInt(startTimeValues[1]));
            this.inputTimeStart.setValue(startTime, true);
        }

        if (this.getAttributeValue("time_end")) {
            let endTime = new Date();
            let startTimeString: string = this.getAttributeValue("time_end");
            let startTimeValues = startTimeString.split(":");
            endTime.setHours(parseInt(startTimeValues[0]));
            endTime.setMinutes(parseInt(startTimeValues[1]));
            this.inputTimeEnd.setValue(endTime, true);
        }
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {
            case "is_time_relative_to_first_booking":
                if (value) {
                    this.hideNode(this.inputDateStart.domNode, true);
                    this.hideNode(this.inputDateEnd.domNode, true);
                } else {
                    this.hideNode(this.inputDateStart.domNode, false);
                    this.hideNode(this.inputDateEnd.domNode, false);
                }
        }
    }

    private _onChangeTimeStart() {
        let newTimeStart: Date = this.inputTimeStart?.getValue();
        let newTimeStartString;
        if (newTimeStart) {
            let hours = newTimeStart.getHours();
            let minutes = newTimeStart.getMinutes();
            newTimeStartString = hours < 10 ? "0" + hours : hours;
            newTimeStartString += ":" + (minutes < 10 ? "0" + minutes : minutes);
        } else {
            newTimeStartString = "";
        }
       
        this.setAttributeValue("time_start", newTimeStartString);
    }

    private _onChangeTimeEnd() {
        let newTimeEnd: Date = this.inputTimeEnd?.getValue();
        let newTimeEndString;
        if (newTimeEnd) {
            let hours = newTimeEnd.getHours();
            let minutes = newTimeEnd.getMinutes();
            newTimeEndString = hours < 10 ? "0" + hours : hours;
            newTimeEndString += ":" + (minutes < 10 ? "0" + minutes : minutes);
        } else {
            newTimeEndString = "";
        }

        this.setAttributeValue("time_end", newTimeEndString);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.inputTimeStart.on("change", lang.hitch(this, this._onChangeTimeStart));
        this.inputTimeEnd.on("change", lang.hitch(this, this._onChangeTimeEnd))
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(HtEndpointScenarioEditor);